import { createContext, useContext } from 'react';

/**
 * Whether the form around a field is shown for reading only. Set by
 * RecordFormDialog, so a shared piece that is no `bindFormFields` field (a
 * repeater, a picker, a time input) can follow it without each dialog
 * threading a prop through.
 */
export const FormReadOnlyContext = createContext(false);

export function useFormReadOnly(): boolean {
    return useContext(FormReadOnlyContext);
}
